import { render, staticRenderFns } from "./shengjiAgenFill.vue?vue&type=template&id=b836c432&scoped=true"
import script from "./shengjiAgenFill.js?vue&type=script&lang=js&external"
export * from "./shengjiAgenFill.js?vue&type=script&lang=js&external"
import style0 from "./shengjiAgenFill.scss?vue&type=style&index=0&id=b836c432&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b836c432",
  null
  
)

export default component.exports